module.exports = __webpack_public_path__ + "img/cards.1045549b.png";